/**
 * Parse a number someone typed. Accepts a decimal comma ("72,5") and
 * thousands separators ("2,300"). Returns null when it isn't a number.
 */
export function parseDecimal(text: string): number | null {
  let t = text.trim().replace(/\s+/g, '');
  if (!t) return null;
  if (/^[1-9]\d{0,2}(,\d{3})+(\.\d+)?$/.test(t)) t = t.replace(/,/g, '');
  else if (/^\d+,\d+$/.test(t)) t = t.replace(',', '.');
  // Plain decimals only: no exponents, hex or other things Number() accepts.
  if (!/^[+-]?(\d+(\.\d*)?|\.\d+)$/.test(t)) return null;
  const n = Number(t);
  return Number.isFinite(n) ? n : null;
}
